import React, { Component } from 'react';
import {MAP, DELETE, OFF} from 'constants/midi-map-modes.js';
import GuildsMenu from 'components/guilds/GuildsMenu.js';
import BPMComponent from './BPMComponent.js';
import TransactionsView from './TransactionsView';
import ClockComponent from './ClockComponent.js';
import PatternsComponent from './PatternsComponent.js';
import ReactDOM, {render} from 'react-dom';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import SubSequencesComponent from './SubSequencesComponent.js';
import SaveModal from 'components/modals/SaveModal.js';
import {setResolution} from 'actions/index.js';
import ToolbarMixButtons from './ToolbarMixButtons.js';
import {setPatternToEditColor} from 'actions/index.js';
import ethereum from 'decentralized/ethereum.js';
import Resolution from 'engine/Resolution.js';
import { connect } from "react-redux";
import SamplePacks from 'decentralized/SamplePacks.js';
import SubToolbar from 'components/toolbar/SubToolbar.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import SamplePack from 'repos/SamplePack.js';
import {setViewMode} from 'actions/index.js';
import {setIsPlayingMix} from 'actions/index.js';
import {setIsRecordingMix} from 'actions/index.js';
import {setCompactMode} from 'actions/index.js';
import {setZIndexHack} from 'actions/index.js';
import {setShowSettings} from 'actions/index.js';
import {dragPattern} from 'actions/index.js';
import { PREFERENCES_VIEW } from "constants/view-modes.js";
import { SEQUENCER_VIEW } from "constants/view-modes.js";
import { MIX_VIEW } from "constants/view-modes.js";
import { ARRANGEMENT_VIEW } from "constants/view-modes.js";
import {setContextualHelp} from "actions/index.js";
import ResolutionDropdown from './ResolutionDropdown.js';
import {CURRENT_PATTERN_BUTTON} from 'constants/contextual-help.js';
import {PATTERN_BUTTON} from 'constants/contextual-help.js';
import {NEW_PATTERN_BUTTON} from 'constants/contextual-help.js';
import {GUILDS_SELECTOR} from 'constants/contextual-help.js';
import {DELETE_PATTERN_BUTTON} from 'constants/contextual-help.js';
import {RESOLUTION_DROPDOWN} from 'constants/contextual-help.js';
import {VIEW_DROPDOWN} from 'constants/contextual-help.js';
import ConnectionStatus from './ConnectionStatus.js';
import Dropdown from 'react-dropdown'
import '../../toolbar.scss';

const samplePacks = new SamplePacks();

class SequencerToolbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            showSaveModal: false,
        };
    }


    goToMixer() {
        this.props.sequencerEngine.keyListener.lastViewMode = this.props.viewMode;
        this.props.setViewMode(MIX_VIEW);
    }

    goToArrangement() {
        this.props.sequencerEngine.keyListener.lastViewMode = this.props.viewMode;
        this.props.setViewMode(ARRANGEMENT_VIEW);
    }

    goToSequencer() {
        this.props.sequencerEngine.keyListener.lastViewMode = this.props.viewMode;
        this.props.setViewMode(SEQUENCER_VIEW);
    }

    goToPreferences() {
        this.props.setViewMode(PREFERENCES_VIEW);
    }

    goToHome() {
        window.location.href = '/explore/';
    }

    toggleViewDropdown() {
        this.props.setZIndexHack(!this.state.dropdownOpen);
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }

    duplicateTrack() {
        this.sequencerEngine.duplicateTrack(this.props.selectedTrack);
    }

    onSave(projectName, saveOption, selectedGuild) {
        this.hideSaveModal();
        this.props.sequencerEngine.save(projectName, saveOption, true, selectedGuild);
    }

    hideSaveModal() {
        this.setState({showSaveModal: false});
    }

    // saves the current sequence to the backend using
    // a name chosen by user via prompt pop up
    async save() {
        this.setState({showSaveModal: true});
    }

    onSelectResolution(option) {
        this.props.sequencerEngine.resolution = option;
        this.props.sequencerEngine.select(
            this.props.sequencerEngine.cursor.track,
            0);
        this.setState(this.state);
    }

    clickPattern(i) {
        let state = this.props.sequencerEngine.store.getState();
        if (state.keyboard.isCommandDown) {
            this.props.setPatternToEditColor(i);
        } else {
            this.props.sequencerEngine.switchToPattern(i);
            if (state.toolbar.patternToEditColor !== undefined) {
                this.props.setPatternToEditColor(i);
            }
            this.setState(this.state);
        }
    }

    onDragStart(patternNumber) {
        this.props.dragPattern(patternNumber);
    }

    onDragOver(e) {
        e.preventDefault();
    }

    onDrop(patternNumber) {
        this.props.sequencerEngine.movePatternTo(this.props.patternDragging, patternNumber);
        this.setState(this.state);
    }

    onPlayMixClicked() {
     }

    onClickRecordMixButton() {
    }

    onCompactClicked() {
        this.props.setCompactMode(!this.props.isCompactMode);
    }

    onNewClicked() {
        if (window.confirm("Are you sure you want to clear this sequence (and lose any work)?")) {
            this.props.sequencerEngine.newSequence();
        }
    }

    get viewMode() {
        return this.props.viewMode;
    }

    getView() {
        if (this.props.viewMode === SEQUENCER_VIEW) {
            return 'SEQUENCER';
        } else if (this.props.viewMode === MIX_VIEW) {
            return 'MIXER';
        } else if (this.props.viewMode === PREFERENCES_VIEW) {
            return 'PREFERENCES';
        } else if (this.props.viewMode === ARRANGEMENT_VIEW) {
            return 'ARRANGEMENT';
        }
        return 'VIEW';
    }

    onStartSequenceRolling() {
        this.props.sequencerEngine.sequenceRolling = true;
    }

    onStopSequenceRolling() {
        this.props.sequencerEngine.sequenceRolling = false;
    }

    render() {
        var patterns = [];
        for (var i=0; i < this.props.sequencerEngine.numberOfPatterns(); i++) {
            patterns.push(i);
        }

        // get max track length
        let maxLength = -1;
        for (let i in this.props.sequencerEngine.tracks) {
            let track = this.props.sequencerEngine.tracks[i];
            let len = track.pattern.length();
            if (maxLength < len) {
                maxLength = len;
            }
        }

        if (maxLength == -1) {
            maxLength = 32;
        }

        return (<div className='top-toolbar'>
                <SaveModal
                sequencerEngine={this.props.sequencerEngine}
                onSave={(name, saveOption, selectedGuild) => this.onSave(name, saveOption, selectedGuild)}
                onHide={() => this.hideSaveModal()}
                show={this.state.showSaveModal}/>
                <div className="main-toolbar">
                <ResolutionDropdown sequencerEngine={this.props.sequencerEngine}/>
                <PatternsComponent sequencerEngine={this.props.sequencerEngine}/>
               <div>

                <SubSequencesComponent sequencerEngine={this.props.sequencerEngine}/>
                <BPMComponent sequencerEngine={this.props.sequencerEngine}/>
                <ClockComponent sequencerEngine={this.props.sequencerEngine}/>
               </div>
                <ToolbarMixButtons sequencerEngine={this.props.sequencerEngine}/>
                <ConnectionStatus sequencerEngine={this.props.sequencerEngine}/>

                {this.props.trackRolling ?
                 <div
                 onMouseDown={() => this.onStartSequenceRolling()}
                 onMouseUp={() => this.onStopSequenceRolling()}
                   className={this.props.sequenceRolling ? "roll-button rolling" : "roll-button"}>ROLL {this.props.rollResolution.toString()} </div> : ''}
                {this.props.midiMapMode !== OFF ?
                 <div
                 className={"roll-button"}>{this.props.midiMapMode === MAP ? 'MIDI MAP' : 'DELETE MIDI MAP'}</div> : ''}
                <ConditionedComponent condition={this.props.viMode}>
                <div className="roll-button command-button">COMMAND</div>
                </ConditionedComponent>
 
                <div className='save-container'>
                <ConditionedComponent condition={this.props.onGoBack}>
                <div onClick={this.props.onGoBack} className="go-back-button">BACK</div>
                </ConditionedComponent>
                <span onMouseOver={() => this.props.setContextualHelp(GUILDS_SELECTOR)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}>
                <TransactionsView store={this.props.sequencerEngine.store}/>
                  <img
                    onClick={() => this.goToSequencer()}
                    src="/sequencer-view.svg"
                    className={this.viewMode === SEQUENCER_VIEW ? "view-mode-icon selected" : "view-mode-icon"}/>
                  <img
                    onClick={() => this.goToMixer()}
                    src="/mix-view.svg"
                    className="view-mode-icon"
                    className={this.viewMode === MIX_VIEW ? "view-mode-icon selected" : "view-mode-icon"}/>
                  <img
                    src="/arrangement-view.svg"
                    onClick={() => this.goToArrangement()}
                    className={this.viewMode === ARRANGEMENT_VIEW ? "view-mode-icon selected" : "view-mode-icon"}/>
                <GuildsMenu store={this.props.sequencerEngine.store}/>
                </span>
                <span onMouseOver={() => this.props.setContextualHelp(VIEW_DROPDOWN)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}>
               </span>
                <div className='light-blue-button common-button' onClick={() => this.props.setShowSettings(true)}>SETTINGS</div>
                <div className='light-blue-button common-button' onClick={() => this.onNewClicked()}>NEW</div>
                <div className='pink-button common-button' onClick={() => this.save()}>SAVE</div>
                </div>
                </div>
                <ConditionedComponent condition={this.props.patternToEditColor !== undefined}>
                <SubToolbar sequencerEngine={this.props.sequencerEngine}/>
                </ConditionedComponent>
               </div>
               );
    }
};

const resolutionOptions = [
    {value: new Resolution(4, false), label:'1/4'},
    {value: new Resolution(4, true), label:'1/4t'},
    {value: new Resolution(8, false), label:'1/8'},
    {value: new Resolution(8, true), label:'1/8t'},
    {value: new Resolution(16, false), label:'1/16'},
    {value: new Resolution(16, true), label:'1/16t'},
    {value: new Resolution(32, false), label:'1/32'},
    {value: new Resolution(32, true), label:'1/32t'}
]

function getResolutionOption(value) {
    for (var i=0; i < resolutionOptions.length; i++) {
        if (resolutionOptions[i].value.resolution == value.resolution &&
           resolutionOptions[i].value.isTriplet == value.isTriplet) {
            return resolutionOptions[i];
        }
    }
    return null;
}

const mapDispatchToProps = dispatch => {
    return {
        setResolution: resolution => dispatch(setResolution(resolution)),
        setViewMode: viewMode => dispatch(setViewMode(viewMode)),
        setShowSettings: show => dispatch(setShowSettings(show)),
        dragPattern: patternNumber => dispatch(dragPattern(patternNumber)),
        setIsPlayingMix: isPlayingMix => dispatch(setIsPlayingMix(isPlayingMix)),
        setPatternToEditColor: pattern => dispatch(setPatternToEditColor(pattern)),
        setIsRecordingMix: isRecordingMix => dispatch(setIsRecordingMix(isRecordingMix)),
        setCompactMode: compact => dispatch(setCompactMode(compact)),
        setZIndexHack: hack => dispatch(setZIndexHack(hack)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
};

const mapStateToProps = state => {
    let id = state.sequencer.sequencerEngine.getSequenceId();
    let isPlaying = state.sequencer.isPlaying[id] || 0;
        
    return {
        midiMapMode: state.midi.midiMapMode,
        isCompactMode: state.sequencer.isCompactMode,
        resolution: state.sequencer.displayResolution,
        sequencerEngine: state.sequencer.sequencerEngine,
        detailsView: state.sequencer.detailsView,
        decentralized: state.sequencer.decentralized,
        viewMode: state.sequencer.viewMode,
        numberOfPatterns: state.sequencer.numberOfPatterns,
        samplePack: state.sequencer.samplePack,
        patternDragging: state.sequencer.patternDragging,
        isRecordingMix: state.mix.isRecordingMix,
        isPlayingMix: state.mix.isPlayingMix,
        isPlaying: isPlaying,
        patternToEditColor: state.toolbar.patternToEditColor,
        patternColors: state.toolbar.patternColors,
        trackRolling: state.sequencer.trackRolling,
        sequenceRolling: state.sequencer.sequenceRolling,
        viMode: state.commands.viMode,
        rollResolution: state.sequencer.resolution
   }
};

export default connect(mapStateToProps, mapDispatchToProps)(SequencerToolbar);
